export default function registerBeforeMiddlewares(router, middlewares) {
  if (!Array.isArray(middlewares))
    throw new Error('Middlewares should be an array!');
  middlewares.forEach(middleware => router.beforeEach(middleware));
}
